module.exports = __webpack_public_path__ + "home-block-5-image@2x-1xCiU1l.jpg";